import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Job } from '../../class/job.class';
import { StatusType } from '../../types/status.type';
import { Task } from '../../class/task.class';
import { StatusEnum } from '../../enums/status.enum';

export const selectJobs = createFeatureSelector<readonly Job[]>('jobs');

export const selectJobsIsLoaded = createSelector(
  selectJobs,
  (jobs: readonly Job[]) => jobs !== undefined && jobs.length > 0
);

export const selectAllJobs = createSelector(
  selectJobs,
  (jobs: readonly Job[]) => jobs ?? []
);

export const selectJobById = (jobId: number) => createSelector(
  selectJobs,
  (jobs: readonly Job[]) => jobs?.find(job => job.id === jobId)
);

export const selectJobsCount = createSelector(
  selectJobs,
  (jobs: readonly Job[]) => jobs?.length ?? 0
);

export const selectJobsByStatus = (status: StatusType) => createSelector(
  selectJobs,
  (jobs: readonly Job[]) => jobs?.filter(job => job.status === status) ?? []
);

export const selectJobsByStatusCount = (status: StatusType) => createSelector(
  selectJobsByStatus(status),
  (jobs: readonly Job[]) => jobs?.length ?? 0
);

export const selectJobIsCompleted = (jobId: number) => createSelector(
  selectJobById(jobId),
  (job: Job | undefined) => job ? job.status === 'COMPLETED' : false
);

export const selectLastJob = createSelector(
  selectAllJobs,
  (jobs: readonly Job[]) => {
    if (!jobs || jobs.length === 0) return null;
    return jobs.reduce((lastJob, currentJob) => {
      return new Date(currentJob.createdAt) > new Date(lastJob.createdAt) ? currentJob : lastJob;
    });
  }
)

export const selectLastTask = (jobId:number) => createSelector(
  selectJobById(jobId),
  (job: Job | undefined) => job?.tasks.pop()
)